import React, { FC }         from "react";
import { useDispatch }       from "react-redux";
import { Button, Icon }      from "semantic-ui-react";
import Customer              from "../../../domain/customer/Customer";
import ReservationRepository from "../../../domain/reservation/ReservationRepository";
import ReservationDataSource from "../../../infrastructure/datasource/reservation/ReservationDataSource";
import RouterDispatcher      from "../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  customer: Customer;
}

const CustomerNextReservationButton: FC<Props> = (props: Props) => {
  const {customer} = props;
  const reservationRepository: ReservationRepository = new ReservationDataSource(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          routerDispatcher.reservation();
          reservationRepository.setReservationCustomer(customer);
        } }
      >
        <Icon name="calendar"/>
        次回予約する
      </Button>
    </>
  );
};

export default CustomerNextReservationButton;
